export default __webpack_public_path__ + "static/media/Meeting Krug 2.799a3a70.jpg";